var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0C5.38278 0 0 5.3832 0 12C0 18.6168 5.38278 24 11.9998 24C18.6167 24 24 18.6168 24 12C24 5.3832 18.6167 0 11.9998 0ZM11.9998 22.4262C6.2508 22.4262 1.5738 17.749 1.5738 12C1.5738 6.25098 6.25074 1.57386 11.9998 1.57386C17.7488 1.57386 22.426 6.25104 22.426 12C22.4261 17.749 17.7487 22.4262 11.9998 22.4262Z",
    fill: "#63A5A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3443 8.07141L10.1564 14.259L7.65509 11.7582C7.34771 11.4512 6.84977 11.451 6.54239 11.7584C6.23489 12.0659 6.23489 12.5639 6.54239 12.8712L9.60018 15.9285C9.75384 16.082 9.95514 16.1588 10.1564 16.1588C10.3577 16.1588 10.5596 16.082 10.7132 15.9283C10.7137 15.9276 10.714 15.927 10.7148 15.9262L17.4569 9.18411C17.7644 8.87691 17.7644 8.37855 17.4569 8.07135C17.1496 7.76397 16.6513 7.76397 16.3443 8.07141Z",
    fill: "#63A5A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMessage);
export default __webpack_public_path__ + "static/media/success-message.96faf7ae.svg";
export { ForwardRef as ReactComponent };